import { createStyles, makeStyles } from "@material-ui/core"

export const useStyles = makeStyles((theme) =>
    createStyles({
        appBar: {
            width: '100%',
            display: 'flex',
            zIndex: 1,
            position: 'fixed',
            justifyContent: 'space-between',
            [theme.breakpoints.down('xs')]: {
                background: 'rgba(56,109,159,1)'
            }
        },
        menuButton: {
            color: 'rgba(56,109,159,1)',
            [theme.breakpoints.down('xs')]: {
                color: '#fff',
            }
        },
        hide: {
            display: "none"
        },
        drawer: {
            width: '240px',
            flexShrink: 0,
        },
        drawerPaper: {
            width: '240px',
            borderRadius: 0
        },
        drawerHeader: {
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
            justifyContent: "flex-end"
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            }),
            marginLeft: -240
        },
        contentShift: {
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen
            }),
            marginLeft: 0
        },
        drawerBottom: {
            flex: "0 0 1",
            height: "auto",
            background: theme.palette.common.white,
        },
        list: {
            padding: '15px 15px'
        },
        listFilho: {
            padding: '12px 15px'
        },
        divider: {
            width: '100%',
            height: '2px!important',
            background: '#c2c2c2'
          }
    })
) 